export const SET_AUTHENTICATED_USER = 'SET_AUTHENTICATED_USER';
export const SIGNOUT = "SIGNOUT";